import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=58a84b30&scoped=true&"
import script from "./DashboardCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardCard.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=58a84b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a84b30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBadge,VCard,VCardSubtitle,VCardTitle,VCol,VImg})
